export default {
  web: true,
};



// WEBPACK FOOTER //
// ./mobile/shared/store/env.js